import * as React from 'react'

const GiftBoxIcon: React.FC = () => (
  // tslint:disable:max-line-length
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M1.83267 4.56516H3.36735C3.16491 4.24479 3.03133 3.88518 2.99324 3.50486C2.87156 2.2894 3.51168 1.19982 4.60146 0.716753C5.60317 0.272726 6.72886 0.45424 7.53946 1.18944L9.47731 2.9457C9.85471 2.53293 10.3972 2.2735 10.9993 2.2735C11.6025 2.2735 12.1459 2.53375 12.5234 2.9478L14.4637 1.18923C15.2756 0.454034 16.4009 0.27322 17.4021 0.717C18.4916 1.2001 19.1319 2.29005 19.0098 3.50548C18.9716 3.88551 18.8381 4.24496 18.6358 4.56516H20.166C20.9254 4.56516 21.541 5.18078 21.541 5.94015V8.00265C21.541 8.38232 21.2332 8.69016 20.8535 8.69016H1.14515C0.76549 8.69016 0.457642 8.38236 0.457642 8.00265V5.94015C0.457684 5.18078 1.07326 4.56516 1.83267 4.56516ZM13.0619 4.336V4.56516H16.2961C17.1507 4.56516 17.8232 3.76852 17.6098 2.87882C17.5157 2.48701 17.2329 2.15301 16.8671 1.98394C16.3649 1.75177 15.8084 1.8263 15.3866 2.20815L13.0613 4.31574C13.0614 4.32254 13.0619 4.32921 13.0619 4.336ZM4.35752 3.32231C4.40875 4.03688 5.05422 4.56524 5.7706 4.56524H8.93685V4.33609C8.93685 4.32797 8.93734 4.31994 8.93742 4.31183C8.41067 3.83433 7.26793 2.79861 6.64815 2.23681C6.29591 1.91756 5.80305 1.76853 5.34745 1.90442C4.69366 2.09944 4.30971 2.65543 4.35752 3.32231Z"
        fill="#F6F7FF"
      />
      <path
        d="M20.166 10.0654V20.1488C20.166 20.9082 19.5504 21.5238 18.791 21.5238H12.3744V10.0654H20.166Z"
        fill="#F6F7FF"
      />
      <path
        d="M9.625 10.0654V21.5238H3.20834C2.44892 21.5238 1.83335 20.9082 1.83335 20.1488V10.0654H9.625Z"
        fill="#F6F7FF"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="21.0833" height="21.0833" fill="white" transform="matrix(-1 0 0 1 21.541 0.458496)" />
      </clipPath>
    </defs>
  </svg>
)

export default React.memo(GiftBoxIcon)
